import { useState, useEffect } from "react";

const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_id",
  "utm_term",
  "utm_content",
];
const CLICK_ID_PARAMS = ["fbclid", "gclid"];

// UTMs arrive on the landing URL but forms are often submitted from other pages
// (/contact etc.), so captured params are persisted for the session and merged
// under any params present on the current URL.
const STORAGE_KEY = "utmTracking";

// The Meta pixel stores its click id in the first-party _fbc cookie; it feeds
// the offline-conversion events, so it is captured alongside the url click ids.
const readFbcCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : undefined;
};

const readStoredTracking = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch (error) {
    return {};
  }
};

const useUTMParams = () => {
  const [utmParams, setUTMParams] = useState({});
  const [clickIds, setClickIds] = useState({});
  const [userIP, setUserIP] = useState("");

  const getUserIP = async () => {
    try {
      const result = await fetch("https://api.ipify.org?format=json");
      const data = await result.json();
      setUserIP(data.ip);
    } catch (error) {
      console.error("Error getting user IP:", error);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const collect = (params) =>
      params.reduce((acc, param) => {
        const value = searchParams.get(param);
        if (value) acc[param] = value;
        return acc;
      }, {});

    const stored = readStoredTracking();
    const mergedUtmParams = { ...stored.utmParams, ...collect(UTM_PARAMS) };
    const fbc = readFbcCookie();
    const mergedClickIds = {
      ...stored.clickIds,
      ...collect(CLICK_ID_PARAMS),
      ...(fbc ? { fbc } : {}),
    };
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ utmParams: mergedUtmParams, clickIds: mergedClickIds }),
      );
    } catch (error) {
      // storage unavailable (private mode) - fall back to current-URL params only
    }

    setUTMParams(mergedUtmParams);
    setClickIds(mergedClickIds);
  }, []);

  useEffect(() => {
    getUserIP();
  }, []);

  return {
    utmParams,
    clickIds,
    ipAddress: userIP,
    originalUrl: window.location.href,
  };
};

export default useUTMParams;
